// extracted by mini-css-extract-plugin
export default {"row":"ProductsDashboard_row__uNzFT","col":"ProductsDashboard_col__smiSf","card":"ProductsDashboard_card__-93Lm"};